import requestProvider from "./axiosHandler";

const getAllBrand = () => {
    return requestProvider
        .get("/brand/get-all")
};

const getBrandsAsSelect = () => {
    return requestProvider
        .get('/brand/select')
};

const createBrand = (list) => {
    return requestProvider
        .post("/brand", {
            name: list.name,
            code: list.code,
            description: list.description
        })
};

const deleteBrand = (id) => {

    return requestProvider
        .delete(`/brand/${id}`)
};

const getBrandById = (id) => {

    return requestProvider
        .get(`/brand/${id}`)
};

const updateBrand = (list) => {

    return requestProvider
        .put("/brand", {
            name: list.name,
            code: list.code,
            description: list.description,
            id: list.id
        })
};

const getBrandsWithPage = (page = 0, pageSize = 10) => {
    return requestProvider
        .get(`/brand?field=createdDate&order=desc&page=${page}&per_page=${pageSize}`)
}; 

export {getAllBrand, createBrand, deleteBrand, getBrandById, updateBrand, getBrandsAsSelect, getBrandsWithPage}